import { Breadcrumb, Button, Card, Col, Dropdown, Flex, Layout, Row, Select, Space, Table, Tabs } from "antd";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";

import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";
import FormItem from "antd/es/form/FormItem";
import { ReactComponent as DownloadICon } from "../../../assets/icon/downloadIcon.svg";
import WorkingTimeModal from "./reportModal/WorkingTimeModal";
import { DownloadOutlined, FileFilled, MoreOutlined } from "@ant-design/icons";
import TabPane from "antd/es/tabs/TabPane";
import { get2DecimalPointsWithCommas } from "components/numberFormatDigits";
import ExpenseModal from "./reportModal/ExpenseModal";
import FilesModal from "./reportModal/FilesModal";
import { getFilesExpense } from "features/employee/services/employeeApi";
import { ReactComponent as DocumentIcon } from "../../../assets/icon/documentRound.svg";

const WorkingExpenseComponent = ({
    showReport,
    employeeOptions = [],
    reportTableWoringTime = [],
    initialValues,
    onChange = () => { },
    pagination = {},
    pagination2 = {},
    departmentOptions = [],
    positionOptions = [],
    workInLocationList = [],
    handleSearch = () => { },
    exportWorkingTimeGroupReport = () => { },
    exportWorkingTimeGroupReportAll = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { },
    isDownloading = false,
    ddlDate = () => { }
}) => {
    const { t, i18n } = useTranslation();
    const currentYear = new Date().getFullYear().toString();
    function formatDateTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/BBBB HH:mm`);
    }
    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/BBBB`);
    }

    const [fileHandle, setFileHandle] = useState({
        open: false,
        fileList: []
    })


    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 100,
            render: (_, record, idx) => {
                return <span style={{ color: "#667085" }}>{(pagination.pageNo - 1) * pagination.size + idx + 1}</span>;
            },

        },
        {
            title: <div className="text-table">{t('employee.label.employee_id')}</div>,
            dataIndex: "employeeDetails",
            key: "employeeDetails",
            align: "left",
            width: 150,
            render: (_, record) => {
                return _.employeeNo;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeDetails",
            key: "employeeDetails",
            align: "left",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return _.name + " " + _.surName;
                }
                return _.name + " " + _.surName;
            },

        },
        {
            title: <div className="text-table">{t('expense.createDate')}</div>,
            dataIndex: "createDate",
            key: "createDate",
            align: "center",
            width: 150,
            render: formatDateTime
        },
        {
            title: <div className="text-table">{t('expense.reuestDate')}</div>,
            dataIndex: "startDate",
            key: "startDate",
            align: "center",
            width: 150,
            render: formatDate
        },
        {
            title: <div className="text-table">{t('expense.sequence')}</div>,
            dataIndex: "sequence",
            key: "sequence",
            align: "center",
            width: 150,
        },
        {
            title: <div className="text-table">{t('expense.welfareType')}</div>,
            dataIndex: "welfareDetails",
            key: "welfareDetails",
            align: "left",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return _.welfareNameEn
                }
                return _.welfareName
            },
        },
        {
            title: <div className="text-table">{t('expense.approveStatus')}</div>,
            dataIndex: "approveStatus",
            key: "approveStatus",
            align: "center",
            width: 150,
            render: (record, _) => {
                console.log("_", _);
                if (i18n.language === "en") {
                    return _.approveStatusEn
                }
                return _.approveStatus
            },
        },
        {
            title: <div className="text-table">{t('expense.amount')}</div>,
            dataIndex: "totalExpense",
            key: "totalExpense",
            align: "right",
            width: 150,
            render: (_, record) => {
                return (
                    get2DecimalPointsWithCommas(_)
                )
            }
        },
        {
            title: <div className="text-table">{t('expense.files')}</div>,
            dataIndex: "attachFiles",
            key: "attachFiles",
            align: "center",
            width: 150,
            render: (_, record) => {
                return _ && <DocumentIcon style={{ width: 20, cursor: 'pointer', }} onClick={async () => {
                    let data = await getFilesExpense({ id: record.id })
                    setFileHandle({
                        open: true,
                        fileList: data?.data ?? []
                    })
                }} />
            }
        },

    ];

    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);
    return (
        <MainLayout>
            <FilesModal fileHandle={fileHandle} setFileHandle={setFileHandle} />
            <ExpenseModal name={t("expenseReport.header")} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} exportWorkingTimeGroupReport={exportWorkingTimeGroupReportAll} exportExpenseSummary={exportWorkingTimeGroupReport} isDownloading={isDownloading} />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t('report.header'), href: "" },
                        { title: t('expense_group.header'), href: "" },
                        { title: t('expenseReport.header') }
                    ]} />
                    <h2>{t('expenseReport.header')}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        // workingTimeDate
                        // workingTimeDatePicker
                        if ((prev['workingTimeDate'] !== curv['workingTimeDate']) && curv['workingTimeDate'] != null) {
                            curv['workingTimeDatePicker'] = null
                        }
                        if ((prev['workingTimeDatePicker'] !== curv['workingTimeDatePicker']) && curv['workingTimeDatePicker'] != null) {
                            curv['workingTimeDate'] = null
                        }
                        return ((prev['workingTimeDate'] !== curv['workingTimeDate']) && curv['workingTimeDate'] != null)
                            || ((prev['workingTimeDatePicker'] !== curv['workingTimeDatePicker']) && curv['workingTimeDatePicker'] != null)
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={12}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={12}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t('warning_letter.label.employee')}
                                                        size="large"
                                                    />
                                                </Col>
                                                {/* <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        multiple={true}
                                                        // mode="multiple"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                        tree={true}
                                                    // onChange={handleChange}
                                                    />
                                                </Col> */}
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                {/* <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        multiple={true}
                                                        // mode="multiple"
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        // onChange={handleChange}
                                                        size="large"
                                                        tree={true}
                                                    />
                                                </Col> */}
                                                <Col span={12}>
                                                    <FormSelect
                                                        required={getFieldValue("workingTimeDatePicker") == null}
                                                        name="workingTimeDate"
                                                        type="range"
                                                        options={ddlDate()}
                                                        label={t('my_request.label.totalDuration')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('my_request.label.totalDuration')}
                                                        size="large"
                                                        sortBy="value"
                                                    />
                                                </Col>
                                                <Col span={12}>
                                                    <FormDatePicker
                                                        required={getFieldValue("workingTimeDate") == null}
                                                        name="workingTimeDatePicker"
                                                        type="range"
                                                        options={ddlDate()}
                                                        label={t('start-date-to-end-date')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-date-to-end-date')}
                                                        size="large"
                                                        sortBy="value"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>

                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>
                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadICon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <TableAntd
                                                    onChange={onChange}
                                                    pagination={pagination}
                                                    columns={columns}
                                                    dataSource={reportTableWoringTime}
                                                    rowKey={(record) => record.id}
                                                    scroll={{ x: scrollX }}
                                                    tableLayout="fixed"
                                                />
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    );
}

export default WorkingExpenseComponent;
